import moment from 'moment'

import { OnSchedHelpers }  from '../OnSchedHelpers'
import { OnSchedResponse } from '../../OnSchedResponse'
import { OnSchedRest }     from '../../OnSchedRest'


export const MonthNext = (event, element) => {
  var elTimesRow = document.querySelector('.onsched-row.display-times');
  if (elTimesRow) {
    elTimesRow.classList.toggle('remove-display-times');
    setTimeout(() => {
      elTimesRow.classList.toggle('remove-display-times');
      elTimesRow.classList.toggle('display-times');
    }, 500);
  }
  if (!event.target.classList.contains('disabled')) {
    event.target.disabled = true;
    event.preventDefault = true;
  
    var lastDayDate = OnSchedHelpers.ParseDate(event.target.dataset.lastday);
    var nextDate = OnSchedHelpers.AddDaysToDate(lastDayDate, 1);
  
    var elSelectTimezone = document.getElementById('onsched-timezone-button');
    const timezoneName = elSelectTimezone.dataset.tz;
    var url = OnSchedHelpers.CreateAvailabilityUrl(element.onsched.apiBaseUrl, element.params, nextDate, timezoneName);
  
    var calendarHtml = OnSchedTemplates.calendarSelectorFromDate(nextDate, element.onsched.locale);
    var elCalendar = document.querySelector(".onsched-calendar");
    elCalendar.innerHTML = calendarHtml;
  
    // calculate available days to pull when mounting
    url = OnSchedHelpers.AddUrlParam(url, "dayAvailabilityStartDate",
        OnSchedHelpers.CreateDateString(OnSchedHelpers.GetFirstCalendarDate(nextDate)));
    url = OnSchedHelpers.AddUrlParam(url, "dayAvailability", OnSchedHelpers.GetCalendarDays(nextDate));
    url = OnSchedHelpers.AddUrlParam(url, "firstDayAvailable", "true");
  
    var elTimes = document.querySelector(".onsched-available-times");
    elTimes.innerHTML = "";
  
    OnSchedHelpers.ShowProgress();
    // disable navigation while rest call in progress
    var elMonthPrev = document.querySelector(".onsched-availability .month-prev");
    var elMonthNext = document.querySelector(".onsched-availability .month-next");
    elMonthNext.disabled = true;
    elMonthPrev.disabled = true;        
    OnSchedRest.Get(url, function (response) {
      let el = document.getElementById(element.id);
      let detail = response;

      el.dispatchEvent(new CustomEvent("getAvailability", { detail }));
      OnSchedResponse.GetAvailability(element, response, nextDate);
    })
  }
}
